import gql from 'graphql-tag';

export default gql`
  mutation updateCustomCustodian(
    $id: String!
    $bankAddress: String
    $description: String
    $name: String!
    $swiftCode: String
  ) {
    custodian: updateCustomCustodian(
      id: $id
      bankAddress: $bankAddress
      description: $description
      name: $name
      swiftCode: $swiftCode
    ) {
      id
      type
    }
  }
`;
